export enum ForbiddenReason {
  PermissionDenied = 'permission_denied',
  AssetAccessDenied = 'asset_access_denied',
  EmailNotVerified = 'email_not_verified',
  NoSelectedAssets = 'no_selected_assets',
  EmbeddedViolation = 'embedded_violation',
  ResourceAccessDenied = 'resource_access_denied',
}

interface ForbiddenNotificationConfig {
  message: string;
  action?: string;
  id: string;
  closable?: boolean;
}

export const FORBIDDEN_NOTIFICATION_MAP: Record<ForbiddenReason, ForbiddenNotificationConfig> = {
  [ForbiddenReason.PermissionDenied]: {
    message: "You don't have permission to perform this action. Contact your administrator.",
    id: 'permission_denied',
    closable: true,
  },
  [ForbiddenReason.AssetAccessDenied]: {
    message: 'You no longer have access to this asset class.',
    action: 'Reload application',
    id: 'reload_application',
  },
  [ForbiddenReason.EmailNotVerified]: {
    message: 'Please verify your email address to continue.',
    id: 'email_not_verified',
    closable: true,
  },
  [ForbiddenReason.NoSelectedAssets]: {
    message: 'No asset classes are selected. Please reload the application.',
    action: 'Reload application',
    id: 'reload_application',
  },
  [ForbiddenReason.EmbeddedViolation]: {
    message: 'This action is not available in embedded mode.',
    id: 'embedded_violation',
    closable: true,
  },
  [ForbiddenReason.ResourceAccessDenied]: {
    message: 'You no longer have access to this resource.',
    action: 'Reload application',
    id: 'reload_application',
  },
};

export const DEFAULT_FORBIDDEN_NOTIFICATION: ForbiddenNotificationConfig = {
  message: 'You no longer have access to a required resource.',
  action: 'Reload application',
  id: 'reload_application',
};
